module.exports = __webpack_public_path__ + "img/irish-immigrants.1cf62c38.png";